import React, { useReducer, useState, useEffect } from "react";
import CartContext from "./CartContext";
import { CartReducer } from "./CartReducer";
import { SHOW_HIDE_CART, ADD_TO_CART, REMOVE_CART_ITEM } from "./Types";
import { sumItems, decreaseItems } from "./CartReducer";

const cartFromStorage = localStorage.getItem("cart")
  ? JSON.parse(localStorage.getItem("cart"))
  : [];

const CartState = ({ children }) => {
  const initalState = {
    cartItems: cartFromStorage,
    ...sumItems(cartFromStorage),
    showCart: false,
    // cartItems: [],
  };
  const [subTotal, setSubTotal] = useState();
  const [decreaseTotal, setDecreaseTotal] = useState();
  // useEffect(() => {
  //   const total = initalState.cartItems.reduce(
  //     (a, b) => a + b.price * b.quantity,
  //     0
  //   );
  //   setSubTotal(total.toFixed(2));

  // const reducedTotal = initalState.cartItems.reduce(
  //   (a, b) => a - b.price * b.quantity,
  //   0
  // );
  // setDecreaseTotal(reducedTotal.toFixed(2));
  // });
  const [state, dispatch] = useReducer(CartReducer, initalState);

  const addToCart = (item) => {
    dispatch({ type: ADD_TO_CART, payload: item });
  };

  const showHideCart = () => {
    dispatch({ type: SHOW_HIDE_CART });
  };

  const removeItem = (item) => {
    dispatch({ type: REMOVE_CART_ITEM, payload: item });
  };

  return (
    <CartContext.Provider
      value={{
        ...state,
        showCart: state.showCart,
        cartItems: state.cartItems,
        addToCart,
        showHideCart,
        removeItem,
        subTotal,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartState;
